module.exports = __webpack_public_path__ + "img/map.d3060cb4.svg";